<template>
    <div class="py-12">
        <div class="flex justify-center text-grey-dark">
            <button
                @click="filter = 'dining'"
                class="mx-6 uppercase text-sm py-4 px-6 focus:outline-none"
                :class="{
                    'bg-collection-teal text-white ': filter === 'dining',
                    'border border-grey-lighter ': filter !== 'dining'
                }"
            >
                {{ devise.buttonOne.text }}
            </button>
            <button
                @click="filter = 'all-plus'"
                class="uppercase text-sm py-4 px-6 focus:outline-none"
                :class="{
                    'bg-collection-teal text-white ': filter === 'all-plus',
                    'border border-grey-lighter ': filter !== 'all-plus'
                }"
            >
                {{ devise.buttonTwo.text }}
            </button>
        </div>
        <div class="w-full flex justify-center">
            <div
                class="container flex flex-col md:flex-row py-12"
                :class="{
                    'md:flex-row-reverse': devise.imagesOnLeft.checked === true
                }"
            >
                <div class="relative w-full md:w-2/5" key="dining">
                    <general-slider :devise="devise" inline-template>
                        <slither-slider :devise="devise" class="w-full">
                            <div>
                                <img
                                    class="w-full h-full bg-cover"
                                    v-devise-image="{
                                        image: devise.image1,
                                        breakpoint: breakpoint
                                    }"
                                    :style="{ height: '100%', width: '100%' }"
                                />
                            </div>

                            <div v-if="devise.image2.enabled">
                                <img
                                    class="w-full h-full bg-cover"
                                    v-devise-image="{
                                        image: devise.image2,
                                        breakpoint: breakpoint
                                    }"
                                    :style="{ height: '100%', width: '100%' }"
                                />
                            </div>

                            <div v-if="devise.image3.enabled">
                                <img
                                    class="w-full h-full bg-cover"
                                    v-devise-image="{
                                        image: devise.image3,
                                        breakpoint: breakpoint
                                    }"
                                    :style="{ height: '100%', width: '100%' }"
                                />
                            </div>

                            <template slot="previous">
                                <icon-left-arrow
                                    color="#fff"
                                    :w="50"
                                    :h="50"
                                ></icon-left-arrow>
                            </template>
                            <template slot="next">
                                <icon-right-arrow
                                    color="#fff"
                                    :w="50"
                                    :h="50"
                                ></icon-right-arrow>
                            </template>
                        </slither-slider>
                    </general-slider>
                </div>
                <div class="w-3/5 pl-12">
                    <transition mode="out-in" tag="div" name="fade">
                        <div v-if="filter === 'dining'">
                            <h3 class="font-sans-lato font-bold text-3xl mb-4">
                                {{ devise.titleOne.text }}
                            </h3>
                            <div v-html="devise.descriptionOne.text"></div>
                        </div>
                    </transition>

                    <transition mode="out-in" tag="div" name="fade">
                        <div v-if="filter === 'all-plus'">
                            <h3 class="font-sans-lato font-bold text-3xl mb-4">
                                {{ devise.titleTwo.text }}
                            </h3>
                            <div v-html="devise.descriptionTwo.text"></div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AllInclusivePlus",

    data() {
        return {
            filter: "dining",
            iconWidth: 40,
            iconHeight: 50,
            color: "currentcolor"
        };
    }
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
    transition: opacity 500ms;
}

.fade-leave-active {
    transition: all 0ms;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
    overflow: hidden;
}
</style>
